const columns = [
    {
        title: "ID",
        dataIndex: "id",
        width: "100px",
        ellipsis: true,
        key: "id"
    },
    {
        title: "版本名称",
        dataIndex: "name",
        ellipsis: true,
        width: "200px",
        key: "name",
    },
    {
        title: "描述",
        dataIndex: "abstract",
        ellipsis: true,
        width: "200px",
        key: "abstract"
    },
    {
        title: "状态",
        dataIndex: "status",
        width: "100px",
        ellipsis: true,
        key: "status",
        scopedSlots: {customRender: "status"}
    },
    {
        title: "操作",
        key: "action",
        width: "200px",
        scopedSlots: {customRender: "action"}
    }
]

export default columns
